module.exports = __webpack_public_path__ + "static/img/2020.4c61ec7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2020.png
// module id = 8lXz
// module chunks = 1